// Paleta de colores corporativa - Tema rojo
export const palette = {
  primary: {
    main: "#d32f2f",
    light: "#ff6659",
    dark: "#9a0007",
    contrastText: "#ffffff",
  },
  secondary: {
    main: "#f57c00",
    light: "#ffad42",
    dark: "#bb4d00",
    contrastText: "#ffffff",
  },
  error: {
    main: "#f44336",
    light: "#e57373",
    dark: "#d32f2f",
    contrastText: "#ffffff",
  },
  warning: {
    main: "#ff9800",
    light: "#ffb74d",
    dark: "#f57c00",
    contrastText: "#000000",
  },
  info: {
    main: "#2196f3",
    light: "#64b5f6",
    dark: "#1976d2",
    contrastText: "#ffffff",
  },
  success: {
    main: "#4caf50",
    light: "#81c784",
    dark: "#388e3c",
    contrastText: "#ffffff",
  },
  grey: {
    50: "#fafafa",
    100: "#f5f5f5",
    200: "#eeeeee",
    300: "#e0e0e0",
    400: "#bdbdbd",
    500: "#9e9e9e",
    600: "#757575",
    700: "#616161",
    800: "#424242",
    900: "#212121",
  },
  background: {
    default: "#fafafa",
    paper: "#ffffff",
  },
  text: {
    primary: "#212121",
    secondary: "#757575",
    disabled: "#bdbdbd",
  },
  divider: "#e0e0e0",
  // Colores personalizados para el sistema
  custom: {
    plant: "#2e7d32",
    process: "#1565c0",
    room: "#ef6c00",
    machine: "#5e35b1",
    catalog: "#d32f2f",
    operationalGreen: "#43a047",
    maintenanceYellow: "#ffa726",
    repairRed: "#ef5350",
    retiredGrey: "#9e9e9e",
  },
};
